<template>
  <div class="card-home" :style="`background-image: url(${imageSrc})`">
    <div class="card-home__info">
      <p class="card-home__title">{{ title }}</p>
      <p class="card-home__subtitle">{{ subtitle }}</p>
      <div class="card-home__actions">
        <button-base type="primary" class="card-home__join-btn" @click="openModalSync(ModalName.SIGN_UP)">
          {{ button?.label }}
        </button-base>
        <atomic-socials class="card-home__socials" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { ModalName } from '@skeleton/consts/modals';

  import type { IHomePage } from '~/types';

  const props = defineProps<IHomePage['banner']>();

  const { openModalSync } = useModalStore();

  const imageSrc = computed(() => {
    {
      const src = props.images?.backgroundImage;
      return src ? src.replace(/\.\w+$/, '.webp') : '';
    }
  });
</script>

<style src="~/assets/styles/components/card/home.scss" lang="scss" />
